import _ from 'underscore';
import Localizer from 'localizer';

export const DAYS = [
    {
        name: 'SUNDAY',
        propKey: 'day.0'
    },
    {
        name: 'MONDAY',
        propKey: 'day.1'
    },
    {
        name: 'TUESDAY',
        propKey: 'day.2'
    },
    {
        name: 'WEDNESDAY',
        propKey: 'day.3'
    },
    {
        name: 'THURSDAY',
        propKey: 'day.4'
    },
    {
        name: 'FRIDAY',
        propKey: 'day.5'
    },
    {
        name: 'SATURDAY',
        propKey: 'day.6'
    }
];

var ATPConfigUtil = {
    setupModes: {
        Create: 'Create',
        Edit: 'Edit'
    },

    planTypeIds: {
        '5K': 1,
        '10K': 2,
        HALFMARATHON: 3
    },

    planGoals: {
        runWalk: 'RUN_WALK',
        run: 'RUN',
        pace: 'PACE',
        completion: 'COMPLETION'
    },

    //plan distance in meters
    planDistance: {
        '5K': 5000,
        '10K': 10000,
        HALFMARATHON: 21098
    },

    /**
     * Return plan type string based on planTypeId
     */
    getPlanType: function(planTypeId) {
        var planType = null;
        switch (planTypeId) {
            case 1:
                planType = '5K';
                break;
            case 2:
                planType = '10K';
                break;
            case 3:
                planType = 'HALFMARATHON';
                break;
            default:
                planType = '5K';
        }
        return planType;
    },

    getPlanNameKey(planType) {
        let planNameKey = null;
        switch (planType) {
            case '5K':
                planNameKey = 'active_5k_race';
                break;
            case '10K':
                planNameKey = 'active_10k_race';
                break;
            case 'HALFMARATHON':
                planNameKey = 'active_half_marathon_race';
                break;
            default:
                planNameKey = 'active_5k_race';
                break;
        }
        return planNameKey;
    },

    /**
     * Return localized race type string based on planTypeId
     */
    getPlanRaceType: function(planTypeId) {
        if (planTypeId === 1) {
            return Localizer.localize('training_plans_filter_5k');
        } else {
            return ' ';
        }
    }
};

export default ATPConfigUtil;
